import { z } from "zod";

// The `?error=` vocabulary: the six ways a sign-in can fail, named once.
//
// It lives in `lib/` for the same reason the identity vocabulary does — both
// graphs must name it. The server graph raises these codes (`completeLogin`'s
// outcome union, the route adapters' redirects); the client graph renders a
// message for each (`routes/login.tsx`). `lib/` is the one tier below both, so
// neither has to import upward. See `client/docs/architecture.md`, "The
// dependency rule".
//
// Isomorphic on purpose: keep `node:*` imports out of this file.
export const authErrorCodeSchema = z.enum([
  "oauth_error",
  "state_invalid",
  "provider_mismatch",
  "unknown_provider",
  "exchange_failed",
  "storage_unavailable",
]);

export type AuthErrorCode = z.infer<typeof authErrorCodeSchema>;
